<div class="flxClmn">
	<div class="page-title-container flxClmn-center" *ngIf="!hidePageTitle">
		<div class="page-title-inner-container">
			<span class="page-title">Domains</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">Add and manage domains that can be used to send and receive emails with Trustifi</span>
			<more-info-c class="domains-page-more-info">
				<div class="flxClmn vSpace05" style="flex: 1 0;">
					<span style="font-weight: bold;">It is recommended to verify your domains and enable DKIM signature:</span>
					<ul class="vSpace1" style="margin-top: 0;">
						<li style="color:#484848;">
							<span>When you verify an entire domain, you are verifying all email addresses from that domain automatically</span>
						</li>
						<li style="color:#484848;">
							<span>Using a DKIM signature enhances deliverability with DKIM-compliant ISPs. An email message that is sent using DKIM includes a DKIM-Signature header field that contains a cryptographically signed representation of all, or part, of the message</span>
						</li>
						<li style="color:#484848;">
							<span>MX records added here do not affect the domain's regular email flow</span>
						</li>
					</ul>
				</div>
			</more-info-c>
		</div>
	</div>

	<div class="page-inner-content-holder no-scroll flxClmn">
    	<trustifi-table-c
            class="trustifi-table" style="flex: 1 0; z-index: 5;"
            [list]="userDomains"
            [headers]="[
				{text: 'Domain', sortKey: 'domain'},
				{text: 'Status', sortKey: 'verified', tooltip: 'Indicates whether emails can be sent on behalf of this domain'},
				{text: 'DKIM', sortKey: 'dkim_verified', tooltip: 'Indicates whether emails sent on behalf of this domain will conform with the domain\'s DKIM policy'},
				{text: 'MAIL FROM', sortKey: 'mail_from_verified', tooltip: 'The emails you send will be marked as originating from your domain and bounce/feedback can reach back to you. You need to publish an SPF record in order to prove that Trustifi is authorized to send email from your domain'},
				{text: 'Email Feedback Forwarding', sortKey: 'email_feedback_forwarding', tooltip: 'Notify senders by email whenever a message sent from this domain produces bounce or complaint feedback (those emails are sent from mailer-daemon@amazonses.com)'},
				{text: 'SPF', sortKey: 'spf_verified', tooltip: 'Ensure that all Trustifi related services for Inbound and Outbound will be authenticated'},
				{text: 'Assigned To', sortKey: 'assigned_to'},
			]"
            [cellsPrototype]="[
				{html: 'domainCell'},
				{html: 'statusCell'},
				{html: 'dkimCell'},
				{html: 'mailFromCell'},
				{html: 'emailFeedbackCell'},
				{html: 'spfCell'},
				{html: 'assignedToCell'},
			]"
            [bulkActions] = "{
				enable: true,
				selectBulkActionCb:	selectMultipleDomainsAction,
				initBulkActionsFunction: showBulkDomainsActions,
				showInRed: {enable: true, terms: ['delete']}
			}"
            [cellActions] = "{
				enable: true,
				selectItemActionCb:	selectDomainAction,
				initActionsFunction: showDomainActions,
				showInRed: {enable: true, terms: ['delete']}
			}"
            (searchFunction)="searchDomain($event.searchTerm, $event.activeFilters)"
            [filterData]="filterData"
            [options]="{
				exportToCsvFunction: exportToCsv,
				loadingTableFlag: loadingDomainsInProcess,
				itemsNameSingular: 'domain',
				refreshFunction: getDomains,
				defaultSortKey: '-created'
			}"
    >
		<ng-template #customCells let-item let-cellId="cellId">
			<!--CC: domain cell with chevron indicating the row is expandable (taken from user-permissions.component.html -> emailCell)-->
			<div *ngIf="cellId === 'domainCell'" class="flxRow hSpace05" style="align-items: center; cursor: pointer;"
				 (click)="toggleDomainExpand(item, $event)">
				<i class="far fa-angle-right" style="transition: 0.2s;" [ngStyle]="{'transform': item.isExpanded ? 'rotate(90deg)' : 'none'}"></i>
				<span>{{item.domain}}</span>
			</div>
			<div *ngIf="cellId === 'statusCell'">
				<span [ngStyle]="item.verified ? {'color': 'green'} : {'color': 'darkorange'}">{{item.verified ? 'Can send' : 'Cannot send'}}</span>
			</div>
			<div *ngIf="cellId === 'dkimCell'">
				<span [ngStyle]="item.dkim_verified ? {'color': 'green'} : {'color': 'darkorange'}">{{item.dkim_verified ? 'Verified' : 'Unverified'}}</span>
			</div>
			<div *ngIf="cellId === 'mailFromCell'">
				<span [ngStyle]="item.mail_from_verified ? {'color': 'green'} : {'color': 'darkorange'}">{{item.mail_from_verified ? 'Verified' : 'Unverified'}}</span>
			</div>
			<div *ngIf="cellId === 'emailFeedbackCell'">
				<span [ngStyle]="item.email_feedback_forwarding ? {'color': 'green'} : {'color': 'darkorange'}">{{item.email_feedback_forwarding ? 'Enabled' : 'Disabled'}}</span>
			</div>
			<div *ngIf="cellId === 'spfCell'">
				<span [ngStyle]="item.spf_verified ? {'color': 'green'} : {'color': 'darkorange'}">{{item.spf_verified ? 'Verified' : 'Unverified'}}</span>
			</div>
			<div *ngIf="cellId === 'assignedToCell'">
				<span>{{item.assigned_to || 'Your plan'}}</span>
			</div>
		</ng-template>

		<!--CC: expandable row - self-contained DNS records details (card layout taken from user-permissions.component.html -> #subRow)-->
		<ng-template #subRow let-item>
			<tr style="border-bottom: none;" *ngIf="item.isExpanded">
				<td colspan="9" class="overflownV" style="background: #fafafa; border-bottom: solid 1px #e3e4e4;">
					<div class="flxClmn vSpace2" style="padding: 22px 25px 20px; cursor: default;">
						<!--CC: top bar - email feedback forwarding toggle on the left, export on the right-->
						<div class="flxRow-between" style="align-items: center; gap: 15px;">
							<div class="flxRow hSpace05" style="align-items: center;">
								<span style="font-weight: 500;">Email Feedback Forwarding</span>
								<i class="far fa-question-circle" style="font-weight: 400;" tooltip="Notify senders by email whenever a message sent from this domain produces bounce or complaint feedback (those emails are sent from mailer-daemon@amazonses.com)"></i>
								<toggle-switch-c style="margin-left: 10px;"
												 [(model)]="item.email_feedback_forwarding"
												 [hideText]="true"
												 (onChange)="emailForwardingChange(item)"></toggle-switch-c>
							</div>
							<btn-c variant="outlined" endIcon="far fa-file-csv" (action)="getDomainDkimAndTokenCsv(item)">
								Export
							</btn-c>
						</div>

						<!--CC: one card per DNS record type, each on its own full-width row so long DNS values have room-->
						<div class="flxClmn vSpace2">
							<!--Identity-->
							<div class="flxClmn vSpace2" style="border: solid 1px #e3e4e4; border-radius: 6px; padding: 20px 25px; background: white;">
								<div class="flxRow-between" style="align-items: center; gap: 10px;">
									<div class="flxRow hSpace05" style="align-items: center;">
										<b>Identity</b>
										<i class="far fa-question-circle" style="font-weight: 400;" tooltip="Indicates whether emails can be sent on behalf of this domain"></i>
									</div>
									<div class="flxRow hSpace1" style="align-items: center;">
										<span style="font-size: 0.85em; font-weight: 500;" [ngStyle]="item.verified ? {'color': 'green'} : {'color': 'darkorange'}">{{item.verified ? 'Verified' : 'Unverified'}}</span>
										<btn-c variant="text" endIcon="far fa-sync-alt" btnTooltip="Verify" (action)="isDomainIdentityVerified(item)"></btn-c>
									</div>
								</div>
								<table class="simpleDataTable w-100">
									<thead>
										<tr>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase; padding-left: 10px;">Type</th>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Host</th>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Value</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td style="padding-left: 10px;">TXT</td>
											<td><a (click)="copyText('_amazonses');"><span class="copy-link">_amazonses</span></a></td>
											<td style="word-break: break-all;"><a (click)="copyText(item.data?.verify_token);"><span class="copy-link">{{item.data?.verify_token}}</span></a></td>
										</tr>
									</tbody>
								</table>
							</div>

							<!--DKIM-->
							<div class="flxClmn vSpace2" style="border: solid 1px #e3e4e4; border-radius: 6px; padding: 20px 25px; background: white;">
								<div class="flxRow-between" style="align-items: center; gap: 10px;">
									<div class="flxRow hSpace05" style="align-items: center;">
										<b>DKIM</b>
										<i class="far fa-question-circle" style="font-weight: 400;" tooltip="Indicates whether emails sent on behalf of this domain will conform with the domain's DKIM policy"></i>
									</div>
									<div class="flxRow hSpace1" style="align-items: center;">
										<span style="font-size: 0.85em; font-weight: 500;" [ngStyle]="item.dkim_verified ? {'color': 'green'} : {'color': 'darkorange'}">{{item.dkim_verified ? 'Verified' : 'Unverified'}}</span>
										<btn-c variant="text" endIcon="far fa-sync-alt" btnTooltip="Verify" (action)="isDomainDkimVerified(item)"></btn-c>
									</div>
								</div>
								<table class="simpleDataTable w-100">
									<thead>
										<tr>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase; padding-left: 10px;">Type</th>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Host</th>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Pointer</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let dkim of item.data?.dkim">
											<td style="padding-left: 10px;">CNAME</td>
											<td style="word-break: break-all;"><a (click)="copyText(dkim + '._domainkey');"><span class="copy-link">{{dkim}}._domainkey</span></a></td>
											<td style="word-break: break-all;"><a (click)="copyText(dkim + '.dkim.amazonses.com');"><span class="copy-link">{{dkim}}.dkim.amazonses.com</span></a></td>
										</tr>
									</tbody>
								</table>
							</div>

							<!--MAIL FROM-->
							<div class="flxClmn vSpace2" style="border: solid 1px #e3e4e4; border-radius: 6px; padding: 20px 25px; background: white;" *ngIf="item.data?.from_record">
								<div class="flxRow-between" style="align-items: center; gap: 10px;">
									<div class="flxRow hSpace05" style="align-items: center;">
										<b>MAIL FROM</b>
										<i class="far fa-question-circle" style="font-weight: 400;" tooltip="The emails you send will be marked as originating from your domain and bounce/feedback can reach back to you. You need to publish an SPF record in order to prove that Trustifi is authorized to send email from your domain"></i>
									</div>
									<div class="flxRow hSpace1" style="align-items: center;">
										<span style="font-size: 0.85em; font-weight: 500;" [ngStyle]="item.mail_from_verified ? {'color': 'green'} : {'color': 'darkorange'}">{{item.mail_from_verified ? 'Verified' : 'Unverified'}}</span>
										<btn-c variant="text" endIcon="far fa-sync-alt" btnTooltip="Verify" (action)="isDomainMailFromVerified(item)"></btn-c>
									</div>
								</div>
								<table class="simpleDataTable w-100">
									<thead>
										<tr>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase; padding-left: 10px;">Type</th>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Host</th>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Value / Pointer</th>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Priority</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td style="padding-left: 10px;">TXT</td>
											<td><a (click)="copyText('trustifi');"><span class="copy-link">trustifi</span></a></td>
											<td style="word-break: break-all;"><a (click)="copyText('v=spf1 include:amazonses.com ~all');"><span class="copy-link">v=spf1 include:amazonses.com ~all</span></a></td>
											<td></td>
										</tr>
										<tr>
											<td style="padding-left: 10px;">MX</td>
											<td><a (click)="copyText('trustifi');"><span class="copy-link">trustifi</span></a></td>
											<td style="word-break: break-all;"><a (click)="copyText('feedback-smtp.us-east-1.amazonses.com');"><span class="copy-link">feedback-smtp.us-east-1.amazonses.com</span></a></td>
											<td><a (click)="copyText('10');"><span class="copy-link">10</span></a></td>
										</tr>
									</tbody>
								</table>
							</div>

							<!--SPF-->
							<div class="flxClmn vSpace2" style="border: solid 1px #e3e4e4; border-radius: 6px; padding: 20px 25px; background: white;">
								<div class="flxRow-between" style="align-items: center; gap: 10px;">
									<div class="flxRow hSpace05" style="align-items: center;">
										<b>SPF</b>
										<i class="far fa-question-circle" style="font-weight: 400;" tooltip="Add include:_spf.trustifi.com to the existing SPF (TXT) record of the root domain, before the final -all / ~all. This authorizes Trustifi's relay and notification servers to send on behalf of your domain. The status is checked against the root domain's SPF record - not the trustifi subdomain records above."></i>
									</div>
									<div class="flxRow hSpace1" style="align-items: center;">
										<span style="font-size: 0.85em; font-weight: 500;" [ngStyle]="item.spf_verified ? {'color': 'green'} : {'color': 'darkorange'}">{{item.spf_verified ? 'Verified' : 'Unverified'}}</span>
										<btn-c variant="text" endIcon="far fa-sync-alt" btnTooltip="Verify" (action)="isDomainSpfVerified(item)"></btn-c>
									</div>
								</div>
								<table class="simpleDataTable w-100">
									<thead>
										<tr>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase; padding-left: 10px;">Type</th>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Host</th>
											<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Add to existing value</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td style="padding-left: 10px;">TXT</td>
											<td style="word-break: break-all;"><a (click)="copyText('@');"><span class="copy-link">@</span></a> <span style="color: grey; font-size: 0.85em;">(root: {{item.domain}})</span></td>
											<td style="word-break: break-all;"><a (click)="copyText('include:_spf.trustifi.com');"><span class="copy-link">include:_spf.trustifi.com</span></a></td>
										</tr>
									</tbody>
								</table>
								<span style="color: grey; font-size: 0.85em;">Edit the SPF record that already exists on {{item.domain}} (starts with "v=spf1") and insert the value before the final "-all" / "~all". Do not create a second SPF record.</span>
								<div class="flxRow hSpace1" style="align-items: center;" *ngIf="!item.spf_verified">
									<btn-c variant="outlined" startIcon="far fa-magic"
										   btnTooltip="Preview the change, then let your DNS provider add include:_spf.trustifi.com to your existing SPF record"
										   (action)="openSpfEntriPopup(item)">
										Add to my SPF record
									</btn-c>
									<span style="color: grey; font-size: 0.85em;">or add it manually as described above</span>
								</div>
							</div>
						</div>
					</div>
				</td>
			</tr>
		</ng-template>

        <div tableButtons>
            <div class="flxRow hSpace1" style="align-items: center;">
				<btn-c endIcon="far fa-plus"
	                   (action)="addActiveDomain();">
					Add Domain
				</btn-c>

                <btn-c variant="outlined" endIcon="far fa-sync-alt"
                     [loading]="{flag: reverifyAllInProcess, text: 'Re-verifying'}"
                     [isDisabled]="loadingDomainsInProcess || !userDomains?.length"
                     btnTooltip="Re-check the Identity, DKIM, MAIL FROM and SPF records of every domain in real time (one domain at a time)"
                     (action)="reverifyAllDomains();">
                    Re-verify All
                </btn-c>
            </div>
        </div>
    </trustifi-table-c>
	</div>

	<popup-c class="bs-enabled" *ngIf="addActiveDomainPopup?.show"
			 head="Add Domain" size="dynamic"
			 (closeCb)="addActiveDomainPopup.show = false;"
			 (confirmCb)="addDomain(addActiveDomainPopup.domainsName)"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Add Domain', disabled: addActiveDomainPopup.applyInProcess || !addActiveDomainPopup.domainsName.length}}">
		<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
			<p style="font-size: 14px;">Please fill in the domain name</p>

			<div class="align-items-center flex-row gap-3">
				<div>Domain:</div>
				<input type="text" placeholder="Domain's name (required)"
					   style="width:330px;" [required]="true"
					   [(ngModel)]="addActiveDomainPopup.domainsName"
					   [ngStyle]="!addActiveDomainPopup.domainsName && addActiveDomainPopup.errMsg ? {'border-color':'red'} : {}"/>
			</div>
			<p>You will be asked to verify the DNS records that will be provided.</p>
			<!-- CC: when checked, the Auto Verify (Entri) flow runs right after the domain is added -->
			<checkbox class="transparent-box success-color"
					  [(model)]="addActiveDomainPopup.autoVerify"
					  tooltipTxt="Automatically configure the required DNS records with your DNS provider after the domain is added">
				<span>Auto verify</span>
			</checkbox>
			<p class="text-danger" *ngIf="addActiveDomainPopup.errMsg">{{addActiveDomainPopup.errMsg}}</p>
		</div>

	</popup-c>

    <popup-c class="overflownV" *ngIf="assignDomainToAdminPopup?.show"
           head="Assign Domain to Plan"
           size="dynamic"
           (closeCb)="assignDomainToAdminPopup = null"
           (confirmCb)="assignDomainToAdmin()"
           [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: assignToAdminInProcess}}">
        <div class="flex-column f-1-0 gap-1" style="overflow: visible;">
            <span>Assign the domain <b>{{assignDomainToAdminPopup.domainToAssign.domain}}</b> to another plan</span>
            <br/>
            <div class="flex-column gap-2" *ngIf="assignDomainToAdminPopup?.adminsList">
                <span style="color: black;">Select the new plan from the following list:</span>
				<app-dropdown-c style="width: 320px;"
								text="{{assignDomainToAdminPopup?.selectedAdmin?.formattedDisplay || 'Select'}}"
								[items]="assignDomainToAdminPopup.adminsList"
								itemDisplayKey="formattedDisplay" [enableSearch]="true"
								(onItemClicked)="assignDomainToAdminPopup.selectedAdmin = $event.item;"></app-dropdown-c>
            </div>
        </div>
    </popup-c>

    <!--Verification with Amazon popup-->
    <popup-c *ngIf="amazonVerificationPopup?.show"
           head="Amazon Route 53 domain verification" size="medium"
           (closeCb)="amazonVerificationPopup = null;">
        <div class="f-1-0" style="color: #3c4043; font-size: 14px; overflow: auto;">
            <span style="font-size: 16px;">Manually add Trustifi DNS records to the Amazon Route 53 DNS Provider</span>
            <br/><br/>
            <div style="max-height: 40vh; overflow: auto; background: rgba(0,0,65,0.007);">
                <p style="line-height: 1.75rem; margin-block-end: 0;">
                    Please follow instructions below :<br/>
                    1. Go to <a style="color: cornflowerblue; font-weight: bold;" href="https://us-east-1.console.aws.amazon.com/route53/v2/hostedzones#" target="_blank">AWS Route53 Hosted Zones page</a> (Login to AWS will be required).<br/>
                    2. Select the required hosted zone.<br/>
                    3. Click on the button <strong>Import zone file</strong>.<br/>
                    4. Copy the following DNS data and paste it in the input area :
                </p>
                <div style="align-items: center; margin:15px;" class="flxRow-start hSpace2">
                    <div style="font-size: 16px; width: 85%; background: #bac9d642; height: 130px; align-items: center; padding: 12px;" class="flxClmn-center">
                        <span style="font-weight:500; overflow: auto; width: 100%; word-break: break-all;" class="hide-scrollbar click-select-all">
                            {{getAmazonDomainConfigString(amazonVerificationPopup.domainObj)}}
                        </span>
                    </div>
                    <a (click)="copyAmazonDomainConfigString();">
                        <i class="fas fa-copy copy-link" tooltip="Copy DNS data"></i>
                    </a>
                </div>
                <p style="line-height: 1.75rem; margin: 0;">
                    5. Click on <strong>Import</strong> to complete the process.
                </p>
            </div>
        </div>
    </popup-c>

	<popup-c class="bs-enabled" *ngIf="unassignFromAdminPopup?.show"
			 head="Unassign domain" size="dynamic"
			 (closeCb)="unassignFromAdminPopup.show = false;"
			 (confirmCb)="unassignFromAdminPopup?.doneCb()"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Unassign', disabled: assignToAdminInProcess || unassignFromAdminPopup.verifyDomain.model !== unassignFromAdminPopup.verifyDomain.equalsTo}}">
		<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
			<div class="d-flex gap-1 text-danger pt-2" style="font-size: 14px;">
				<i class="zmdi zmdi-alert-circle-o" style="font-size: 1.5rem; margin-top: -6px;"></i>
				{{unassignFromAdminPopup.subTitle}}
			</div>

			<ul>
				<li *ngFor="let text of unassignFromAdminPopup.bodyDetails; trackBy: gs.trackByIndex">{{text}}</li>
			</ul>

			<div class="align-items-center flex-row gap-3">
				<div>Domain:</div>
				<input type="text" placeholder="Please enter domain you want to unassign"
					   style="width:330px;" [required]="true"
					   [(ngModel)]="unassignFromAdminPopup.verifyDomain.model"
					   [ngStyle]="unassignFromAdminPopup.verifyDomain.model && unassignFromAdminPopup.verifyDomain.model !== unassignFromAdminPopup.verifyDomain.equalsTo ? {'border-color':'red'} : {}"/>
			</div>
		</div>
	</popup-c>

	<!-- SPF auto-add through Entri (#15531) - separate from the SES "Auto Verify" flow -->
	<popup-c class="bs-enabled" *ngIf="spfEntriPopup?.show"
			 head="Add Trustifi to your SPF record" size="dynamic"
			 [subTitle]="spfEntriPopup.domainObj.domain"
			 (closeCb)="closeSpfEntriPopup()"
			 (confirmCb)="spfEntriPopup.step === 'applied' ? recheckSpfAfterApply() : startSpfEntri()"
			 [buttons]="{
				cancel: ['preview', 'loading', 'starting', 'entri'].includes(spfEntriPopup.step) ? 'Cancel' : 'Close',
				confirm: spfEntriPopup.step === 'preview' || spfEntriPopup.step === 'starting'
					? {text: 'Continue to DNS provider', loading: spfEntriPopup.step === 'starting'}
					: (spfEntriPopup.step === 'applied' && !spfEntriPopup.result?.spfVerified ? {text: 'Verify again', loading: spfEntriPopup.verifying} : null)
			 }">
		<div class="flex-column f-1-0 gap-3" style="overflow: auto; max-width: 640px; font-size: 14px;">

			<!-- loading -->
			<div class="flxRow hSpace1" style="align-items: center;" *ngIf="spfEntriPopup.step === 'loading'">
				<i class="fas fa-spinner fa-spin"></i>
				<span>Reading the SPF record of {{spfEntriPopup.domainObj.domain}} from its nameservers…</span>
			</div>

			<!-- message carried from a refused start (e.g. the record changed since the preview) -->
			<div class="flxRow hSpace1" style="color: darkorange;" *ngIf="spfEntriPopup.errMsg && !['loading', 'failed'].includes(spfEntriPopup.step)">
				<i class="fas fa-exclamation-triangle" style="margin-top: 3px;"></i>
				<span>{{spfEntriPopup.errMsg}}</span>
			</div>

			<!-- preview -->
			<ng-container *ngIf="['preview', 'starting', 'entri'].includes(spfEntriPopup.step) && spfEntriPopup.preflight?.current">
				<span>Trustifi will be added to your existing SPF record. Review the change:</span>
				<div class="flex-column gap-1">
					<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">Current record</b>
					<code style="word-break: break-all; padding: 8px 10px; background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 4px;">{{spfEntriPopup.preflight.current.record}}</code>
				</div>
				<div class="flex-column gap-1" *ngIf="spfExpectedParts(spfEntriPopup.preflight.expected?.record) as parts">
					<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">After{{spfEntriPopup.preflight.expected?.nestedRecord ? ' - root record' : ''}}{{spfEntriPopup.preflight.provider ? ' (' + spfEntriPopup.preflight.provider.name + ')' : ''}}</b>
					<code style="word-break: break-all; padding: 8px 10px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 4px;">{{parts[0]}}<b style="color: #15803d;">{{parts[1]}}</b>{{parts[2]}}</code>
				</div>
				<!-- GoDaddy: the merged mechanisms live in a separate dc-<id>._spfm record -->
				<div class="flex-column gap-1" *ngIf="spfEntriPopup.preflight.expected?.nestedRecord && spfExpectedParts(spfEntriPopup.preflight.expected.nestedRecord) as parts">
					<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">After - {{spfEntriPopup.preflight.expected.nestedHost}}</b>
					<code style="word-break: break-all; padding: 8px 10px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 4px;">{{parts[0]}}<b style="color: #15803d;">{{parts[1]}}</b>{{parts[2]}}</code>
				</div>
				<span style="color: grey; font-size: 0.9em;">
					DNS lookups: {{spfEntriPopup.preflight.current.lookups}} → {{spfEntriPopup.preflight.expected.lookups}} of 10 allowed.
					<ng-container *ngIf="spfPolicySame(spfEntriPopup.preflight.current.allQualifier, spfEntriPopup.preflight.expected.allQualifier)">Your policy ({{spfPolicyLabel(spfEntriPopup.preflight.current.allQualifier)}}) stays the same.</ng-container>
					<ng-container *ngIf="!spfPolicySame(spfEntriPopup.preflight.current.allQualifier, spfEntriPopup.preflight.expected.allQualifier)">Your policy changes from {{spfPolicyLabel(spfEntriPopup.preflight.current.allQualifier)}} to {{spfPolicyLabel(spfEntriPopup.preflight.expected.allQualifier)}}.</ng-container>
				</span>
				<!-- DNS provider specific behaviour (GoDaddy nested record, "~all" applied by Domain Connect providers, ...) -->
				<div class="flxRow hSpace1" *ngFor="let notice of spfEntriPopup.preflight.notices || []"
					 style="font-size: 0.9em; padding: 8px 10px; border-radius: 4px;"
					 [ngStyle]="notice.level === 'warning' ? {'background': '#fffbeb', 'border': '1px solid #fde68a'} : {'background': '#eff6ff', 'border': '1px solid #bfdbfe'}">
					<i class="fas" style="margin-top: 3px;" [ngClass]="notice.level === 'warning' ? 'fa-exclamation-triangle' : 'fa-info-circle'" [ngStyle]="{'color': notice.level === 'warning' ? '#d97706' : '#2563eb'}"></i>
					<span>{{notice.text}}</span>
				</div>
				<span *ngIf="!spfEntriPopup.preflight.expected?.nestedRecord">{{spfEntriPopup.preflight.reason}} Your DNS provider opens in a secure Entri window where you confirm the change.</span>
				<span *ngIf="spfEntriPopup.preflight.expected?.nestedRecord">Only your SPF record and the record {{spfEntriPopup.preflight.provider?.name}} creates for it are changed. Nothing else in your DNS is touched. Your DNS provider opens in a secure Entri window where you confirm the change.</span>
				<div class="flxRow hSpace1" style="font-size: 0.9em; padding: 8px 10px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 4px;">
					<i class="fas fa-exclamation-triangle" style="color: #d97706; margin-top: 3px;"></i>
					<span>If your provider cannot be updated automatically, Entri shows manual steps. In that case <b>edit your existing SPF record</b> and add <b>include:_spf.trustifi.com</b> before "all" - never create a second SPF record, it breaks SPF for all your email.</span>
				</div>
				<div class="flxRow hSpace1" style="align-items: center; color: grey;" *ngIf="spfEntriPopup.step === 'entri'">
					<i class="fas fa-spinner fa-spin"></i>
					<span>Waiting for the DNS provider window…</span>
				</div>
			</ng-container>

			<!-- blocked / disabled: reason + manual instruction -->
			<ng-container *ngIf="spfEntriPopup.step === 'blocked' || spfEntriPopup.step === 'disabled' || spfEntriPopup.step === 'failed'">
				<div class="flxRow hSpace1">
					<i class="fas fa-info-circle" style="color: darkorange; margin-top: 3px;"></i>
					<span *ngIf="spfEntriPopup.step !== 'failed'">{{spfEntriPopup.preflight?.reason}}</span>
					<span *ngIf="spfEntriPopup.step === 'failed'">The record was not applied{{spfEntriPopup.errMsg ? ' (' + spfEntriPopup.errMsg + ')' : ''}}. Nothing was changed in your DNS.</span>
				</div>
				<div class="flex-column gap-1" *ngIf="spfEntriPopup.preflight?.records?.length">
					<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">{{spfEntriPopup.preflight.records.length > 1 ? 'SPF records found' : 'Current record'}}</b>
					<code *ngFor="let record of spfEntriPopup.preflight.records" style="word-break: break-all; padding: 8px 10px; background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 4px;">{{record}}</code>
				</div>
				<div class="flex-column gap-1">
					<span *ngIf="spfEntriPopup.preflight?.reasonCode !== 'noSpfRecord'">To add it manually, edit the SPF (TXT) record on <b>{{spfEntriPopup.domainObj.domain}}</b> and insert this value before the final "-all" / "~all":</span>
					<span *ngIf="spfEntriPopup.preflight?.reasonCode === 'noSpfRecord'">To add it manually, create one TXT record on <b>@</b> ({{spfEntriPopup.domainObj.domain}}) that lists all services sending email for your domain, for example <code>v=spf1 include:spf.protection.outlook.com include:_spf.trustifi.com ~all</code>. The Trustifi part is:</span>
					<a (click)="copyText('include:_spf.trustifi.com');"><span class="copy-link">include:_spf.trustifi.com</span></a>
				</div>
			</ng-container>

			<!-- already verified -->
			<div class="flxRow hSpace1" style="align-items: center; color: green;" *ngIf="spfEntriPopup.step === 'verified'">
				<i class="fas fa-check-circle"></i>
				<span>{{spfEntriPopup.preflight?.reason}}</span>
			</div>

			<!-- after the Entri window: the real verification decides what we show -->
			<ng-container *ngIf="spfEntriPopup.step === 'applied'">
				<div class="flxRow hSpace1" style="align-items: center;" *ngIf="spfEntriPopup.verifying">
					<i class="fas fa-spinner fa-spin"></i>
					<span>{{spfEntriPopup.setupType === 'manual' ? 'Checking' : 'Record applied' + (spfEntriPopup.provider ? ' by ' + spfEntriPopup.provider : '') + '. Verifying'}} your SPF record…</span>
				</div>
				<ng-container *ngIf="!spfEntriPopup.verifying">
					<div class="flxRow hSpace1" style="align-items: center; color: green;" *ngIf="spfEntriPopup.result?.spfVerified">
						<i class="fas fa-check-circle"></i>
						<span>SPF is verified. include:_spf.trustifi.com is now effective for {{spfEntriPopup.domainObj.domain}}.</span>
					</div>
					<!-- what the provider actually wrote (GoDaddy: root points to its dc-<id>._spfm record) -->
					<div class="flex-column gap-1" *ngIf="spfEntriPopup.result?.spfVerified && spfEntriPopup.result.current?.record">
						<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">Your SPF record now</b>
						<code style="word-break: break-all; padding: 8px 10px; background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 4px;">{{spfEntriPopup.result.current.record}}</code>
						<span style="color: grey; font-size: 0.9em;" *ngIf="spfEntriPopup.preflight?.current && !spfPolicySame(spfEntriPopup.preflight.current.allQualifier, spfEntriPopup.result.current.allQualifier)">
							Your policy changed from {{spfPolicyLabel(spfEntriPopup.preflight.current.allQualifier)}} to {{spfPolicyLabel(spfEntriPopup.result.current.allQualifier)}}. To restore it, edit the root SPF record at your DNS provider and change the final "all" term back.
						</span>
					</div>

					<!-- the verification request itself failed -->
					<div class="flxRow hSpace1" *ngIf="spfEntriPopup.resultError">
						<i class="fas fa-exclamation-triangle" style="color: darkorange; margin-top: 3px;"></i>
						<span>The SPF record could not be checked right now. Use "Verify again" in a moment, or the Verify button in the SPF section.</span>
					</div>

					<!-- two SPF records (typically after Entri's manual screen) - must be fixed now -->
					<ng-container *ngIf="spfEntriPopup.result?.urgent">
						<div class="flxRow hSpace1" style="color: #b91c1c; padding: 8px 10px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 4px;">
							<i class="fas fa-exclamation-circle" style="margin-top: 3px;"></i>
							<span>{{spfEntriPopup.result.reason}}</span>
						</div>
						<code *ngFor="let record of spfEntriPopup.result.records" style="word-break: break-all; padding: 8px 10px; background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 4px;">{{record}}</code>
					</ng-container>

					<!-- record unchanged so far: still propagating (automatic) or the manual steps are not done yet -->
					<div class="flxRow hSpace1" *ngIf="!spfEntriPopup.resultError && !spfEntriPopup.result?.spfVerified && !spfEntriPopup.result?.urgent && (!spfEntriPopup.result || spfEntriPopup.result.status === 'ready')">
						<i class="fas fa-hourglass-half" style="color: darkorange; margin-top: 3px;"></i>
						<span *ngIf="spfEntriPopup.setupType !== 'manual'">Record applied{{spfEntriPopup.provider ? ' by ' + spfEntriPopup.provider : ''}}. It can take a few minutes until your DNS provider publishes it. Use "Verify again" in a few minutes.</span>
						<span *ngIf="spfEntriPopup.setupType === 'manual'">Once you have added <b>include:_spf.trustifi.com</b> to your existing SPF record at your DNS provider, use "Verify again".</span>
					</div>

					<!-- any other state (e.g. include added after "all") -->
					<div class="flxRow hSpace1" *ngIf="spfEntriPopup.result && !spfEntriPopup.result.spfVerified && !spfEntriPopup.result.urgent && spfEntriPopup.result.status !== 'ready'">
						<i class="fas fa-info-circle" style="color: darkorange; margin-top: 3px;"></i>
						<span>{{spfEntriPopup.result.reason}}</span>
					</div>
				</ng-container>
			</ng-container>

			<!-- setup link handed to a colleague -->
			<div class="flxRow hSpace1" *ngIf="spfEntriPopup.step === 'shared'">
				<i class="fas fa-paper-plane" style="color: #2563eb; margin-top: 3px;"></i>
				<span>The setup was sent to your colleague. Once they complete it, the SPF status of {{spfEntriPopup.domainObj.domain}} turns Verified on this page.</span>
			</div>
		</div>
	</popup-c>

	<!-- MX change through Entri (inbound domains page): gateway -> mail platform. Preview first, typed confirmation, MX records only -->
	<popup-c class="bs-enabled" *ngIf="mxChangePopup?.show"
			 head="Change MX records" size="dynamic"
			 [subTitle]="mxChangePopup.domainObj.domain"
			 (closeCb)="closeMxChangePopup()"
			 (confirmCb)="mxChangeConfirm()"
			 [buttons]="mxChangeButtons(mxChangePopup)">
		<div class="flex-column f-1-0 gap-3" style="overflow: auto; max-width: 680px; font-size: 14px;">

			<!-- loading -->
			<div class="flxRow hSpace1" style="align-items: center;" *ngIf="mxChangePopup.step === 'loading'">
				<i class="fas fa-spinner fa-spin"></i>
				<span>Reading the MX records of {{mxChangePopup.domainObj.domain}} from its nameservers and detecting your mail platform…</span>
			</div>

			<!-- message carried from a refused start (e.g. the MX changed since the preview) -->
			<div class="flxRow hSpace1" style="color: darkorange;" *ngIf="mxChangePopup.errMsg && !['loading', 'failed'].includes(mxChangePopup.step)">
				<i class="fas fa-exclamation-triangle" style="margin-top: 3px;"></i>
				<span>{{mxChangePopup.errMsg}}</span>
			</div>

			<!-- preview: choose where the MX records should point. Warnings only - the info notes are collapsed, the impact box and the
			     typed confirmation sit on the confirm step (QA 2026-10-25: the screen was too busy and Continue was below the fold) -->
			<ng-container *ngIf="mxChangePopup.step === 'preview' && mxChangePopup.preflight?.current">
				<span>Incoming email for <b>{{mxChangePopup.domainObj.domain}}</b> currently goes through <b>{{mxChangePopup.preflight.current.provider || 'the servers below'}}</b>. Choose where the MX records should point instead - the suggestion is editable, and nothing is changed until you confirm in the next step.</span>

				<div class="flex-column gap-1">
					<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">Current MX records</b>
					<code *ngFor="let record of mxChangePopup.preflight.current.labels" style="word-break: break-all; padding: 6px 10px; background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 4px;">{{record.priority}} {{record.exchange}} <span style="color: grey;">({{record.label}})</span></code>
				</div>

				<!-- target: a detected platform (suggested first) or custom records -->
				<div class="flex-column gap-2">
					<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">New MX records</b>
					<label style="display: flex; gap: 10px; align-items: flex-start; cursor: pointer; margin: 0;" *ngFor="let candidate of mxChangePopup.preflight.candidates">
						<input type="radio" name="mxTarget" [value]="candidate.key" [(ngModel)]="mxChangePopup.targetKey" style="margin-top: 4px;">
						<div class="flex-column gap-1 f-1-0">
							<span><b>{{candidate.name}}</b><span *ngIf="candidate.key === mxChangePopup.preflight.suggested" style="color: #15803d; font-size: 0.9em;"> - suggested</span>
								<a (click)="candidate.showWhy = !candidate.showWhy; $event.preventDefault(); $event.stopPropagation();" style="font-size: 0.85em; margin-left: 10px;">{{candidate.showWhy ? 'Hide details' : 'Why?'}}</a>
								<a (click)="editMxCandidate(mxChangePopup, candidate); $event.preventDefault(); $event.stopPropagation();" style="font-size: 0.85em; margin-left: 10px;" *ngIf="mxChangePopup.preflight.customAllowed"><i class="fas fa-pencil-alt"></i> Edit records</a></span>
							<code *ngFor="let record of candidate.records" style="word-break: break-all; padding: 6px 10px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 4px;">{{record.priority}} {{record.exchange}}</code>
							<span style="color: grey; font-size: 0.85em;" *ngIf="candidate.showWhy">{{mxEvidenceText(candidate)}}</span>
						</div>
					</label>
					<label style="display: flex; gap: 10px; align-items: flex-start; cursor: pointer; margin: 0;" *ngIf="mxChangePopup.preflight.customAllowed">
						<input type="radio" name="mxTarget" value="custom" [(ngModel)]="mxChangePopup.targetKey" style="margin-top: 4px;">
						<div class="flex-column gap-1 f-1-0">
							<span><b>Other MX records</b> <span style="color: grey; font-size: 0.9em;">(edit a suggestion above, or enter the records your mail platform gave you)</span></span>
							<ng-container *ngIf="mxChangePopup.targetKey === 'custom'">
								<div class="flxRow hSpace1" style="align-items: center;" *ngFor="let record of mxChangePopup.customRecords; let i = index">
									<input type="number" min="0" max="65535" [(ngModel)]="record.priority" placeholder="Priority" style="width: 90px;">
									<input type="text" [(ngModel)]="record.exchange" placeholder="mail server host, e.g. smtp.google.com" class="f-1-0">
									<a (click)="removeMxCustomRecord(mxChangePopup, i)" style="color: grey;"><i class="fas fa-times"></i></a>
								</div>
								<a (click)="addMxCustomRecord(mxChangePopup)" *ngIf="mxChangePopup.customRecords.length < 5" style="font-size: 0.9em;">+ Add record</a>
							</ng-container>
						</div>
					</label>
				</div>

				<!-- warnings the admin must see before continuing; the info notes (old records, gateway keeps billing, ...) fold away -->
				<div class="flxRow hSpace1" *ngFor="let notice of mxNotices(mxChangePopup, 'warning')" style="font-size: 0.9em; padding: 8px 10px; border-radius: 4px;" [ngStyle]="notice.level === 'warning' ? {'background': '#fffbeb', 'border': '1px solid #fde68a'} : {'background': '#eff6ff', 'border': '1px solid #bfdbfe'}">
					<i class="fas" style="margin-top: 3px;" [ngClass]="notice.level === 'warning' ? 'fa-exclamation-triangle' : 'fa-info-circle'" [ngStyle]="{'color': notice.level === 'warning' ? '#d97706' : '#2563eb'}"></i>
					<span>{{notice.text}}</span>
				</div>
				<ng-container *ngIf="mxNotices(mxChangePopup, 'info').length">
					<a (click)="mxChangePopup.showNotes = !mxChangePopup.showNotes" style="font-size: 0.9em;"><i class="fas" [ngClass]="mxChangePopup.showNotes ? 'fa-chevron-up' : 'fa-chevron-down'"></i> {{mxChangePopup.showNotes ? 'Hide the notes' : 'Good to know (' + mxNotices(mxChangePopup, 'info').length + ' notes)'}}</a>
					<ng-container *ngIf="mxChangePopup.showNotes">
						<div class="flxRow hSpace1" *ngFor="let notice of mxNotices(mxChangePopup, 'info')" style="font-size: 0.9em; padding: 8px 10px; border-radius: 4px;" [ngStyle]="notice.level === 'warning' ? {'background': '#fffbeb', 'border': '1px solid #fde68a'} : {'background': '#eff6ff', 'border': '1px solid #bfdbfe'}">
							<i class="fas" style="margin-top: 3px;" [ngClass]="notice.level === 'warning' ? 'fa-exclamation-triangle' : 'fa-info-circle'" [ngStyle]="{'color': notice.level === 'warning' ? '#d97706' : '#2563eb'}"></i>
							<span>{{notice.text}}</span>
						</div>
					</ng-container>
				</ng-container>
				<span style="color: grey; font-size: 0.85em;" *ngIf="!mxTargetReady(mxChangePopup)">Select the new MX records to continue.</span>
			</ng-container>

			<!-- confirm: the impact, the typed domain name, then the Entri window (the server validates the typed name, re-reads the
			     zone and mints the Entri token when "Open DNS provider" is clicked) -->
			<ng-container *ngIf="['confirm', 'starting'].includes(mxChangePopup.step)">
				<a (click)="backToMxPreview()" style="font-size: 0.9em; align-self: flex-start;" *ngIf="mxChangePopup.step === 'confirm'"><i class="fas fa-arrow-left"></i> Back to the records</a>
				<div class="flex-column gap-1">
					<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">New MX records - {{mxTargetName(mxChangePopup)}}</b>
					<code *ngFor="let record of mxTargetRecords(mxChangePopup)" style="word-break: break-all; padding: 6px 10px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 4px;">{{record.priority}} {{record.exchange}}</code>
				</div>
				<div class="flxRow hSpace1" style="font-size: 0.9em; padding: 8px 10px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 4px;">
					<i class="fas fa-exclamation-circle" style="color: #b91c1c; margin-top: 3px;"></i>
					<span><b>This change affects all incoming email of {{mxChangePopup.domainObj.domain}}.</b> A wrong MX record stops email delivery. {{mxChangePopup.preflight?.reason}} Your DNS provider opens in a secure Entri window that lists the existing MX records it is about to replace; nothing changes until you confirm there. If the records cannot be updated automatically, Entri shows manual steps.</span>
				</div>
				<div class="flex-column gap-1">
					<span>Type <b>{{mxChangePopup.domainObj.domain}}</b> to confirm:</span>
					<input type="text" [(ngModel)]="mxChangePopup.confirmDomain" placeholder="{{mxChangePopup.domainObj.domain}}" style="max-width: 320px;" autocomplete="off" [disabled]="mxChangePopup.step === 'starting'">
					<!-- always in the layout (visibility, not *ngIf): toggling it while typing made the popup jump (QA 2026-10-25) -->
					<span style="color: grey; font-size: 0.85em;" [style.visibility]="canStartMxChange(mxChangePopup) || mxChangePopup.step === 'starting' ? 'hidden' : 'visible'">Type the domain name exactly as shown to enable "Open DNS provider".</span>
				</div>
			</ng-container>

			<!-- the Entri window is open: what Entri found out about the change, when its pre-check is available -->
			<ng-container *ngIf="mxChangePopup.step === 'entri' && mxChangePopup.start">
				<div class="flex-column gap-1">
					<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">New MX records - {{mxChangePopup.start.target?.name}}</b>
					<code *ngFor="let record of mxChangePopup.start.target?.records" style="word-break: break-all; padding: 6px 10px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 4px;">{{record.priority}} {{record.exchange}}</code>
				</div>
				<ng-container *ngIf="mxChangePopup.start.entriAnalysis?.available">
					<span>Entri analysed <b>{{mxChangePopup.domainObj.domain}}</b>: DNS provider <b>{{mxChangePopup.start.entriAnalysis.provider || 'unknown'}}</b>, {{mxChangePopup.start.entriAnalysis.automatic ? 'automatic setup after you sign in to the provider' : 'manual setup (Entri shows the records to change)'}}.</span>
					<div class="flex-column gap-1" *ngIf="mxChangePopup.start.entriAnalysis.conflicts?.length">
						<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">Entri will replace these existing records</b>
						<code *ngFor="let record of mxChangePopup.start.entriAnalysis.conflicts" style="word-break: break-all; padding: 6px 10px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 4px; text-decoration: line-through;">{{record.priority}} {{record.exchange}}</code>
					</div>
				</ng-container>
				<div class="flxRow hSpace1" *ngFor="let notice of mxChangePopup.start.entriAnalysis?.notices || []" style="font-size: 0.9em; padding: 8px 10px; border-radius: 4px;" [ngStyle]="notice.level === 'warning' ? {'background': '#fffbeb', 'border': '1px solid #fde68a'} : {'background': '#eff6ff', 'border': '1px solid #bfdbfe'}">
					<i class="fas" style="margin-top: 3px;" [ngClass]="notice.level === 'warning' ? 'fa-exclamation-triangle' : 'fa-info-circle'" [ngStyle]="{'color': notice.level === 'warning' ? '#d97706' : '#2563eb'}"></i>
					<span>{{notice.text}}</span>
				</div>
				<div class="flxRow hSpace1" style="align-items: center; color: grey;">
					<i class="fas fa-spinner fa-spin"></i>
					<span>Waiting for the DNS provider window… Nothing changes until you confirm there.</span>
				</div>
			</ng-container>

			<!-- blocked / disabled / failed -->
			<ng-container *ngIf="mxChangePopup.step === 'blocked' || mxChangePopup.step === 'disabled' || mxChangePopup.step === 'failed'">
				<div class="flxRow hSpace1">
					<i class="fas fa-info-circle" style="color: darkorange; margin-top: 3px;"></i>
					<span *ngIf="mxChangePopup.step !== 'failed'">{{mxChangePopup.preflight?.reason}}</span>
					<span *ngIf="mxChangePopup.step === 'failed'">The MX records were not changed{{mxChangePopup.errMsg ? ' (' + mxChangePopup.errMsg + ')' : ''}}. Nothing was changed in your DNS.</span>
				</div>
				<div class="flex-column gap-1" *ngIf="mxChangePopup.preflight?.current?.labels?.length">
					<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">Current MX records</b>
					<code *ngFor="let record of mxChangePopup.preflight.current.labels" style="word-break: break-all; padding: 6px 10px; background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 4px;">{{record.priority}} {{record.exchange}} <span style="color: grey;">({{record.label}})</span></code>
				</div>
			</ng-container>

			<!-- already direct -->
			<div class="flxRow hSpace1" style="align-items: center; color: green;" *ngIf="mxChangePopup.step === 'verified'">
				<i class="fas fa-check-circle"></i>
				<span>{{mxChangePopup.preflight?.reason}}</span>
			</div>

			<!-- after the Entri window: the zone check decides what we show -->
			<ng-container *ngIf="mxChangePopup.step === 'applied'">
				<div class="flxRow hSpace1" style="align-items: center;" *ngIf="mxChangePopup.verifying">
					<i class="fas fa-spinner fa-spin"></i>
					<span>{{mxChangePopup.setupType === 'manual' ? 'Checking' : 'Records applied' + (mxChangePopup.provider ? ' by ' + mxChangePopup.provider : '') + '. Checking'}} the MX records of {{mxChangePopup.domainObj.domain}}…</span>
				</div>
				<ng-container *ngIf="!mxChangePopup.verifying">
					<div class="flxRow hSpace1" style="align-items: center; color: green;" *ngIf="mxChangePopup.result?.status === 'applied'">
						<i class="fas fa-check-circle"></i>
						<span>{{mxChangePopup.result.reason}}</span>
					</div>
					<div class="flxRow hSpace1" style="color: #b91c1c; padding: 8px 10px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 4px;" *ngIf="mxChangePopup.result?.urgent">
						<i class="fas fa-exclamation-circle" style="margin-top: 3px;"></i>
						<span>{{mxChangePopup.result.reason}}</span>
					</div>
					<div class="flxRow hSpace1" *ngIf="mxChangePopup.result && !mxChangePopup.result.urgent && mxChangePopup.result.status !== 'applied'">
						<i class="fas fa-hourglass-half" style="color: darkorange; margin-top: 3px;"></i>
						<span>{{mxChangePopup.result.reason}}</span>
					</div>
					<div class="flex-column gap-1" *ngIf="mxChangePopup.result?.current?.labels?.length">
						<b style="font-size: 0.85em; color: grey; text-transform: uppercase;">Your MX records now (from your nameservers)</b>
						<code *ngFor="let record of mxChangePopup.result.current.labels" style="word-break: break-all; padding: 6px 10px; background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 4px;">{{record.priority}} {{record.exchange}} <span style="color: grey;">({{record.label}})</span></code>
						<span style="color: grey; font-size: 0.9em;" *ngIf="mxChangePopup.result.status === 'applied' && mxChangePopup.result.propagated">{{mxChangePopup.result.entri?.connected ? 'Entri confirmed the records have propagated.' : 'Public DNS resolvers already return the new records.'}}</span>
						<span style="color: grey; font-size: 0.9em;" *ngIf="mxChangePopup.result.status === 'applied' && !mxChangePopup.result.propagated">Your nameservers publish the new records; public DNS resolvers still return the previous ones. They switch over within the old record's TTL (usually up to an hour). Use "Check again" later to confirm.</span>
					</div>
					<div class="flxRow hSpace1" *ngIf="mxChangePopup.result?.status === 'applied'" style="font-size: 0.9em; padding: 8px 10px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 4px;">
						<i class="fas fa-info-circle" style="color: #2563eb; margin-top: 3px;"></i>
						<span>Next: make sure the Trustifi inbound integration is connected for this plan (Inbound &gt; Plan settings &gt; Integrations), then cancel the gateway service once no more mail arrives through it.</span>
					</div>
					<div class="flxRow hSpace1" *ngIf="mxChangePopup.resultError">
						<i class="fas fa-exclamation-triangle" style="color: darkorange; margin-top: 3px;"></i>
						<span>The MX records could not be checked right now. Use "Check again" in a moment.</span>
					</div>
					<!-- a change that never completes (manual steps not done, wrong target chosen): start over with a fresh preview -->
					<span style="color: grey; font-size: 0.9em;" *ngIf="mxChangePopup.result && mxChangePopup.result.status !== 'applied'">
						Want to choose a different target or begin again? <a (click)="restartMxChange()">Start a new change</a>
					</span>
				</ng-container>
			</ng-container>

			<!-- setup link handed to a colleague -->
			<div class="flxRow hSpace1" *ngIf="mxChangePopup.step === 'shared'">
				<i class="fas fa-paper-plane" style="color: #2563eb; margin-top: 3px;"></i>
				<span>The setup was sent to your colleague. Once they complete it, open "Change MX Record" on this domain again: it shows the result of this change.</span>
			</div>
		</div>
	</popup-c>
</div>
